export type WidgetConfig = {
  uids: string[]
  apiBase: string
  widgetMode: boolean
  demo: boolean
  globalID?: string
  originUrl?: string
  env?: string
  debug?: boolean
  // From /aiq-sdk/widget/enabled. false hides chat (no AI addendum or
  // explicit off). undefined lets settings apply the Terpli default.
  chatEnabled?: boolean
  /**
   * Optional Reviews V2 override. Dash Enable Reviews is the live gate.
   * Also honored via `?reviewsV2=true` or host
   * `localStorage.setItem('aiq:featureFlags:reviewsV2', 'true')`.
   */
  reviewsV2?: boolean
}

let _config: WidgetConfig | null = null

export function setWidgetConfig(config: WidgetConfig): void {
  _config = config
}

export function getWidgetConfig(): WidgetConfig | null {
  return _config
}

export function isEmbedded(): boolean {
  return _config !== null
}
